var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('v-form',{staticClass:"username__textfield"},[_c('v-text-field',{attrs:{"rules":_vm.rules.name,"color":"grey darken-4","label":"ツイート自動生成したいアカウント名を入力","clearable":"","outlined":"","required":"","placeholder":"twigene_aitter"},model:{value:(_vm.bindText),callback:function ($$v) {_vm.bindText=$$v},expression:"bindText"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff3236f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectGenerateUser.vue
// module id = null
// module chunks = 